<template>
  <b-form-select
    v-bind="$attrs"
    :options="options"
    @change="handleChange"
    v-model="selectedYear"
    class="form-control"
  >
    <template #first>
      <b-form-select-option :value="null">
        {{ placeholderText }}
      </b-form-select-option>
    </template>
  </b-form-select>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    startYear: {
      type: Number,
      required: false,
      default: 2022,
    },
    placeholderText: {
      type: String,
      required: false,
      default: 'Ano',
    },
    revertYear: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      selectedYear: this.value,
      options: [],
    };
  },
  watch: {
    startYear(newVal) {
      this.generateYearOptions(newVal);
    },
  },
  mounted() {
    this.generateYearOptions();
  },
  methods: {
    generateYearOptions() {
      this.options = [];
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const differenceBetweenCurrentYearStartYear =
        currentYear - this.startYear;
      for (let i = 0; i <= differenceBetweenCurrentYearStartYear; i++) {
        const nextYear = this.startYear + i;
        this.options.push({
          value: `${nextYear}`,
          text: `${nextYear}`,
        });
      }
      if (this.revertYear) {
        this.options.reverse();
      }
    },
    handleChange() {
      this.$emit('input', this.selectedYear);
    },
  },
};
</script>
